/**
 * Google Tag Manager container ID — prod varsayılanı.
 * GA4 ve diğer etiketler GTM panelinden yönetilir; doğrudan gtag yüklenmez.
 */
export const GTM_CONTAINER_ID =
  (import.meta.env.VITE_GTM_CONTAINER_ID as string | undefined)?.trim() || 'GTM-WSCWLPDB';

/**
 * Yalnızca GTM kullanılmıyorsa devreye girer (staging / fallback).
 * `.env` içinde `VITE_GA_MEASUREMENT_ID` ile geçersiz kılınabilir.
 */
export const GA_MEASUREMENT_ID =
  (import.meta.env.VITE_GA_MEASUREMENT_ID as string | undefined)?.trim() || 'G-K2KN0FPYS7';

export const USE_GTM = Boolean(GTM_CONTAINER_ID);
